module.exports = __webpack_public_path__ + "static/img/logo-neobus.3f01fe2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-neobus.jpg
// module id = 2Nhx
// module chunks = 1